import React from "react";
import { Table } from "antd";

const List = props => {
  const { data = [], columns, defaultText, loading = false, onRowClick, rowClassName } = props;

  const dataWithKey = data.map((v, i) => {
    return { ...v, key: v._id || v.id || i };
  });
  return (
    <Table
      loading={loading}
      dataSource={dataWithKey}
      columns={columns}
      pagination={false}
      locale={{
        emptyText: defaultText
      }}
      onRow={(record, rowIndex) => {
        return {
          onClick: event => {
            if (onRowClick) {
              return onRowClick(record, rowIndex);
            }
          }
        };
      }}
      rowClassName={record => {
        if (rowClassName) {
          return rowClassName(record);
        }
      }}
    />
  );
};

export default List;



// WEBPACK FOOTER //
// src/components/list/List.js